__turbopack_context__.v({
  "blogInnerGrid": "BlogInner-module__nlDfSq__blogInnerGrid",
});
